import { Box, Container, Typography, Grid } from '@mui/material';

const sections = [
    {
        title: '1. Information We Collect',
        body: 'We collect information you provide directly — such as your name, email address, and password when you register — as well as information generated through your use of the platform, including badges you create, issue, or earn, and activity logs.',
    },
    {
        title: '2. How We Use Your Information',
        body: 'We use your information to operate and improve the TC Everywhere platform, to send you transactional emails (badge notifications, password resets), and, where you have opted in, to send product updates. We do not sell your personal data to third parties.',
    },
    {
        title: '3. Badge Data and Open Badges Standard',
        body: 'Badges issued through TC Everywhere are structured as Open Badges. Public badges and their associated metadata (issuer name, criteria, earner evidence) are publicly accessible as part of the Open Badges specification. Private badge data is only accessible to the issuer and designated earners.',
    },
    {
        title: '4. Cookies',
        body: 'We use session cookies to keep you logged in and functional cookies to remember your preferences. We do not use tracking or advertising cookies. You can disable cookies in your browser settings, though some features may not work correctly without them.',
    },
    {
        title: '5. Data Storage and Security',
        body: 'Your data is stored on secure cloud infrastructure (Microsoft Azure). We use industry-standard encryption in transit (TLS) and at rest. Passwords are hashed using bcrypt and never stored in plain text.',
    },
    {
        title: '6. Data Retention',
        body: 'We retain your account data for as long as your account is active. If you close your account, we will delete or anonymize your personal data within 90 days, except where retention is required by law. Badge assertion records may be retained to honour verifiable credential requests.',
    },
    {
        title: '7. Your Rights',
        body: 'Depending on your location, you may have rights to access, correct, delete, or export your personal data. To exercise any of these rights, contact us at privacy@tinyrewards.net. We will respond within 30 days.',
    },
    {
        title: '8. Third-Party Services',
        body: 'We use third-party services for email delivery (AWS SES), cloud storage (Azure Blob), and analytics. These providers are contractually obligated to protect your data and may not use it for any other purpose.',
    },
    {
        title: "9. Children's Privacy",
        body: 'TC Everywhere is not directed at children under the age of 13. We do not knowingly collect personal data from children under 13. If you believe we have inadvertently collected such data, please contact us immediately.',
    },
    {
        title: '10. Changes to This Policy',
        body: 'We may update this policy from time to time. We will notify you of material changes by email or by a notice on the platform. Continued use of TC Everywhere after changes constitutes acceptance of the updated policy.',
    },
    {
        title: '11. Contact',
        body: 'For privacy enquiries, contact us at privacy@tinyrewards.net or via the Contact Us page.',
    },
];

export default function PrivacyPage() {
    const updated = 'March 2026';

    return (
        <>
            <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 8 }}>
                <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
                    <Typography variant="h2" fontWeight={700} gutterBottom>
                        Privacy Policy
                    </Typography>
                    <Typography variant="h6" sx={{ opacity: 0.85 }}>
                        Last updated: {updated}
                    </Typography>
                </Container>
            </Box>

            <Box sx={{ py: 8 }}>
                <Container maxWidth="lg">
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={8}>
                            {sections.map(({ title, body }) => (
                                <Box key={title} sx={{ mb: 4 }}>
                                    <Typography variant="h6" fontWeight={700} gutterBottom>
                                        {title}
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        {body}
                                    </Typography>
                                </Box>
                            ))}
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
}
